import { graphql, useFragment } from 'react-relay';
import type { useSurveyDemographicInformationFragment_demographicProfileUrl$key } from './__generated__/useSurveyDemographicInformationFragment_demographicProfileUrl.graphql';

const demographicProfileUrlFragment = graphql`
  fragment useSurveyDemographicInformationFragment_demographicProfileUrl on Query {
    demographicProfileUrl
    ...useMoreSurveysBannerQuery_profileUrlRef
    profilerUrl
  }
`;

export function useSurveyDemographicInformationFragment(
  demographicProfileUrlRef: useSurveyDemographicInformationFragment_demographicProfileUrl$key,
) {
  return useFragment(demographicProfileUrlFragment, demographicProfileUrlRef);
}
